<template>
    <v-dialog width="500" v-model="visibilidadeDialogo">
        <template slot="activator">
            <div id="linkContato" @click="mostrarCaixaDialogo">
                <span class="linkContato">
                    (ver contato)
                </span>
            </div>
        </template>

        <v-card v-if="caixaVisivel">
            <v-card-title class="primary modal-title" primary-title>
                <span>{{ titulo }}</span>
                <v-btn flat depressed @click="fecharCaixaDialogo">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-data-table v-if="contato.length > 0" :headers="colunas" :items="contato" class="az-table-list tabela-contato" hide-actions>
                    <template slot="items" slot-scope="props">
                        <tr>
                            <td>
                                {{ props.item.atributo === 'REDE_SOCIAL' ? props.item.tipoAtributo : props.item.atributo | azTitleCase}}
                            </td>
                            <td>
                                {{props.item.atributo === 'TELEFONE' ? (props.item.valor.length >=10 ? formatarTelefone(props.item.valor): props.item.valor): props.item.valor }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>

                <v-layout v-else-if="contato.length === 0" wrap white id="nenhumContato">
                    Este fornecedor não possui informações de contato.
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ContatoFornecedor',
    props: {
        titulo: null,
        contato: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            value: {
                required: true
            },
            caixaVisivel: false,
            visibilidadeDialogo: false,
            colunas: [
                {
                    value: 'tipo',
                    sortable: false,
                    width: '20%',
                    text: 'Tipo',
                    class: 'primary--text',
                    align: 'left'
                },
                {
                    value: 'contato',
                    sortable: false,
                    width: '80%',
                    text: 'Contato',
                    class: 'primary--text',
                    align: 'left'
                }
            ]
        }

    },
    methods: {
        mostrarCaixaDialogo() {
            this.caixaVisivel = true
        },
        fecharCaixaDialogo() {
            this.caixaVisivel = false
            this.visibilidadeDialogo = false
        },
        formatarTelefone (telefone) {
            return this.$options.filters.azPhone(telefone.replace(/\D+/g, ''))
        }
    }
}
</script>

<style scoped lang="stylus">
    .tabela-contato
        thead tr th
            font-weight bold !important

        td:first-child
            text-transform capitalize

    .modal-title
        justify-content space-between

        span
            width 90%

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .linkContato
        font-size 12px
        text-decoration underline;
        cursor pointer

    @media (max-width 720px)
        .tabela-contato
            td:nth-of-type(1):before
                content "Tipo:"

            td:nth-of-type(2):before
                content "Contato:"

        .modal-title span
            width 80%
</style>
